// this test will replace the current certificates page with a new design
export default function updateCertificatesTestPage() {
  // handle navbar class on scroll
  // ** this may be deprecated in the future **
  let navbar = document.querySelector("#header");

  document.addEventListener("scroll", () => {
    if (window.scrollY > 205) {
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
    }
  });

  let sjContent = document.querySelector("#skilljar-content");

  // create page header
  let pageHeader = document.createElement("div");
  pageHeader.id = "certificates-header";

  let pageHeaderText = document.createElement("div");
  pageHeaderText.id = "certificates-header-text";

  pageHeaderText.innerHTML = `
        <h1>
            Earn Certificates
        </h1>
        <p>
            Show the world you're a master of productivity.
        </p>
    `;

  pageHeader.append(pageHeaderText);

  // create sub-header content
  let pageSubHeader = document.createElement("DIV");
  pageSubHeader.id = "certificates-subheader";
  let pageSubHeaderText = document.createElement("DIV");
  pageSubHeaderText.id = "certificates-subheader-text";

  pageSubHeaderText.innerHTML = `
        <div>
            <p>
                <span>Become a Productivity Pro | </span>Take a deeper dive into core features and productivity tips to grow your skills and earn ClickUp Certificates.
            </p>
            <p>
                <span>Perfect your  workflow | </span>As a ClickUp Productivity All-Star, you'll have all the skills you need to build the most efficient Workspace and optimize your workflow.
            </p>
            <p>
                <span>Let your networks know | </span>ClickUp Certificates verify your Workspace knowledge. Share your new credentials via LinkedIn and social media.
            </p>
        </div>
        <img src="https://cu-university-static-staging.web.clickup.com/img/cuu-astrocorn.png">
    `;

  pageSubHeader.append(pageSubHeaderText);

  sjContent.prepend(pageSubHeader);
  sjContent.prepend(pageHeader);
}
